module.exports = __webpack_public_path__ + "static/media/settingsNav_blu.d22ade29.svg";